import { render, staticRenderFns } from "./pageDiagnosis5.vue?vue&type=template&id=041383a6&scoped=true"
import script from "./pageDiagnosis5.vue?vue&type=script&lang=js"
export * from "./pageDiagnosis5.vue?vue&type=script&lang=js"
import style0 from "./pageDiagnosis5.vue?vue&type=style&index=0&id=041383a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041383a6",
  null
  
)

export default component.exports